/* eslint-disable  @typescript-eslint/no-explicit-any */
import { IGetInvoiceDetailResponse } from '~/src/repositories/Invoice/models/Invoice'

export function convertInvoiceDetail(data: any): IGetInvoiceDetailResponse {
  const invoices = data.items.map((item: any) => ({
    id: item?.id,
    userName: item?.user?.name ?? 'User Name',
    invoiceType: item?.type,
    status: item?.status,
    invoiceFileName: item?.invoice?.filename,
    invoiceFileUrl: item?.invoice?.url,
  }))

  return {
    invoices,
  }
}
